export enum AnalyticsTypeEnum {
  WORK_MIRROR = 'work_mirror',
  AUTHOR_MIRROR = 'author_mirror',
  READERSHIP_PROFILE = 'readership_profile',
  UNIVERS = 'univers',
  AUDIENCE = 'audience',
  PRIVATE_READERSHIP_PROFILE = 'private_readership_profile',
  PRIVATE_WORK_MIRROR = 'private_work_mirror',
  PRIVATE_AUTHOR_MIRROR = 'private_author_mirror',
  CHRONIQUEUR = 'chroniqueur',
}

export const AnalyticsList = [
  AnalyticsTypeEnum.WORK_MIRROR,
  AnalyticsTypeEnum.AUTHOR_MIRROR,
  AnalyticsTypeEnum.READERSHIP_PROFILE,
  AnalyticsTypeEnum.UNIVERS,
]
export const PrivateAnalyticsList = [
  AnalyticsTypeEnum.AUDIENCE,
  AnalyticsTypeEnum.PRIVATE_READERSHIP_PROFILE,
  AnalyticsTypeEnum.PRIVATE_WORK_MIRROR,
  AnalyticsTypeEnum.PRIVATE_AUTHOR_MIRROR,
  AnalyticsTypeEnum.CHRONIQUEUR,
]
